window.initFileUpload = function(){

    let chooseFile = ($button) => {
        $button.on('click', function() {
            $file = $button.parent().find('input[type="file"]');
            $file.trigger('click');
            $file.on('change', function () {
                let name = this.value.replace(/.*[\/\\]/, '');
                $file.parent().find('small').html(name);
            });
        })
    };

    let $buttons = $('button[data-component="file-upload"]');

    $buttons.each((key, btn) => {
        let $button = $(btn);
        chooseFile($button);
    });

};

initFileUpload();

